export default class productPage {
   constructor(){
   }

   init(){
      const par = this;
      if (window.Shopify && Shopify.Products && typeof Shopify.Products.recordRecentlyViewed === 'function') {
         let recentLimit = 20;
         const recentSection = document.querySelector('[data-section-type="latest-recent"]');
         if (recentSection) {
            const rawLimit = parseInt(recentSection.getAttribute('data-limit'), 10);
            if (Number.isFinite(rawLimit) && rawLimit > 0) {
               recentLimit = rawLimit;
            }
         }
         Shopify.Products.recordRecentlyViewed({ howManyToStoreInMemory: recentLimit });
      }

      $(window).on('keyup', e => {
         if(e.key=='ArrowLeft'){
             $('.arr-l').click();
         }
         if(e.key=='ArrowRight'){
             $('.arr-r').click();
         }
     });

      // Wrap elements with data-id
      $('.product-details--desc h5').each(function(){
         var nexts = $(this).nextUntil('h5');
         var id = $(this).text().toLowerCase().trim();
         $(this).attr('data-toggle', id);
         $(nexts).wrapAll(`<div data-id="${id}"></div>`);
         $(`[data-id="${id}"]`).hide();
      });

      // Toggle visibility on click
      $('[data-toggle]').on('click', function(){
         var id = $(this).attr('data-toggle');
         $(`[data-id="${id}"]`).slideToggle(300);
      });

      $('.multiselect input').on('change', function(){
         $('#variant').val($('.multiselect input:checked').val());
      });

      // Initial setup
      $('.product').addClass('in');
      $('.product-details').addClass('in');
      $('.product-images-container img').first().addClass('cur');

      $('.toggle-osamaksu').on('click', function(){
         $('.osamaksu').toggleClass('in');
      });

      // Navigation arrows
      $('.arr-r, .arr-l').on('click', function() {
         let dir = $(this).hasClass('arr-l') ? -1 : 1;
         let cur = $('.product-images-container img.cur');
         let next = dir === 1 ? cur.next() : cur.prev();
         if (next.length === 0) {
            next = dir === 1 ? $('.product-images-container img').first() : $('.product-images-container img').last();
         }
         cur.removeClass('cur');
         next.addClass('cur');
         $(next).css('left', '');
      });

      // Product option change
      // $('.product-option input').on('change', function(){
      //    par.checkSubmit();
      // });

      // this.checkSubmit();

      // Swipe handlers
      let preventSwipe = false;
      let preventSwipeTimeout = null;
      let touchStartX = 0;
      let touchEndX = 0;
      let touchStartY = 0;
      let touchEndY = 0;

      $('.product-images-container').on('touchstart', function(e){
         touchStartX = e.originalEvent.touches[0].clientX;
         touchStartY = e.originalEvent.touches[0].clientY;
      }).on('touchmove', function(e){
         if (!preventSwipe) {
            let currentX = e.originalEvent.touches[0].clientX;
            let currentY = e.originalEvent.touches[0].clientY;
            let diffX = currentX - touchStartX;
            let diffY = currentY - touchStartY;
            if(Math.abs(diffY) > 30) {
               preventSwipe = true;
               clearTimeout(preventSwipeTimeout);
               preventSwipeTimeout = setTimeout(() => {
                  preventSwipe = false;
               }, 100);
               return false;
            }
            if(Math.abs(diffX) > Math.abs(diffY)){
               if(Math.abs(diffX) > 5){
                  $(this).find('.cur').css({
                     left: currentX - touchStartX
                  });
               }
            }
            touchEndX = currentX;
            touchEndY = currentY;
         } else {
            $('.product-images-container img.cur').css('left', '');
         }
      }).on('touchend', function(){
         if (touchStartX - touchEndX > window.innerWidth*.2) {
            if (!preventSwipe) {
               preventSwipe = true;
               $('.arr-r').click();
               setTimeout(() => {
                  preventSwipe = false;
               }, 500);
            }
         } else if (touchStartX - touchEndX < -window.innerWidth*.2) {
            if (!preventSwipe) {
               preventSwipe = true;
               $('.arr-l').click();
               setTimeout(() => {
                  preventSwipe = false;
               }, 500);
            }
         } else {
            $('.product-images-container img.cur').css('left', '');
         }
      });
   }

   // checkSubmit(){
   //    // Enable or disable the submit button based on checked input options
   //    if ($('.product-option input:checked').length === 0) {
   //       $('button[type="submit"]').addClass('disabled');
   //    } else {
   //       $('button[type="submit"]').removeClass('disabled');
   //    }
   // }
}
